import React from 'react';
import { withRouter } from 'react-router-dom';

import ResultsIcon from 'material-ui/svg-icons/action/assignment-turned-in';
import UsersIcon from 'material-ui/svg-icons/social/people';
import CompaniesIcon from 'material-ui/svg-icons/communication/business';
import GroupsIcon from 'material-ui/svg-icons/navigation/apps';
import MessageIcon from 'material-ui/svg-icons/communication/message';
import HotIcon from 'material-ui/svg-icons/social/whatshot';
import CommentIcon from 'material-ui/svg-icons/communication/chat-bubble-outline';
import TeamsIcon from 'material-ui/svg-icons/social/group';
import SmsIcon from 'material-ui/svg-icons/notification/sms';

import AdminOnly from '../containers/private/AdminOnly';

import MenuLink from './basic/MenuLink';

const Sidebar = () => {
  return (
    <div className="App-sidebar">
      {/*<MenuLink path="/settings/basic">Basic</MenuLink>*/}
      <MenuLink path="/settings/companies" icon={<CompaniesIcon color="white" />}>
        Companies
      </MenuLink>
      <AdminOnly>
        <MenuLink path="/settings/accounts/groups" icon={<GroupsIcon color="white" />}>
          Account groups
        </MenuLink>
      </AdminOnly>
      <MenuLink path="/settings/teams" icon={<TeamsIcon color="white" />}>
        Teams
      </MenuLink>
      <MenuLink path="/data/results" icon={<ResultsIcon color="white" />}>
        Results
      </MenuLink>
      <MenuLink path="/data/chats/stats" icon={<MessageIcon color="white" />}>
        Chats
      </MenuLink>
      <AdminOnly>
        <MenuLink path="/settings/users" icon={<UsersIcon color="white" />}>
          Users
        </MenuLink>
      </AdminOnly>
      <AdminOnly>
        <MenuLink path="/settings/opportunities" icon={<HotIcon color="white" />}>
          Opportunities
        </MenuLink>
      </AdminOnly>
      <AdminOnly>
        <MenuLink path="/ai/prompts/tester" icon={<CommentIcon color="white" />}>
          Prompt tester
        </MenuLink>
        <MenuLink path="/ai/prompts/tester/echo-pulse-full" className="Menu-link-subitem">
          Echo Pulse
        </MenuLink>
        <MenuLink path="/ai/prompts/echo-pulse-result-chat" className="Menu-link-subitem">
          Echo Pulse Result Chat
        </MenuLink>
        <MenuLink path="/tools/sms-test" icon={<SmsIcon color="white" />}>
          SMS test
        </MenuLink>
      </AdminOnly>
    </div>
  );
};

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar.js